// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toggletip[data-v-9e02b02c]{bottom:4px;position:relative}.toggletip__message[data-v-9e02b02c]{bottom:42px;font-size:90%;line-height:1.5;opacity:.9;position:absolute;z-index:10}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
